import { environment } from '../../environments/environment';
import { AuthService } from '../shared/core/auth.service';
import { UsersProject } from './user-management.model';
import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { AppService } from '../app.service';
import { ProjectItem } from '../project/projectItem';
import { IUserInfo, IUserInProject } from '../shared/core/user-info.model';
import { MessageBrokerService } from '../shared/core/message-broker.service';
import { ErrorModel } from '../shared/core/error.model';
import { UserManagementService } from './user-management.service';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { SharedUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { ComponentCanDeactivate } from '../shared/core/index';
import { HelpUserComponent } from './user-help.component';
import { UserMenuComponent } from './user-menu.component';

@Component(
  {
    selector: 'user-management',
    standalone: false,
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.css']
  }
)

export class UserManagementComponent implements OnInit, AfterViewInit, ComponentCanDeactivate{
  @ViewChild('projectTerm', { static: false }) projectTerm: ElementRef;
  @ViewChild('userTerm', { static: false }) userTerm: ElementRef;
  @ViewChild(HelpUserComponent, { static: false }) helpComponent: HelpUserComponent;
  @ViewChild(UserMenuComponent, { static: false }) userMenuComponent: UserMenuComponent;

  projectTermControl = new FormControl();
  userTermControl = new FormControl();
  searchResults: Array<ProjectItem>;
  searchUsersResults: Array<IUserInfo>;
  appUserInfo: IUserInfo = new IUserInfo();
  isClearanceUser: boolean;
  usersInProject: UsersProject;
  userManagementForm: FormGroup;
  _selectedProject: ProjectItem;
  userSearchRunning: boolean = false;
  selectedUserEmail: string;
  selectedUserStatus: string;
  userMenuClientX;
  userMenuClientY;
  _searchUsersLabel: { [type: string]: string } =
  {
    default: "Name / Email",
    noproject: 'Select a project above first before searching for users'
  };
  searchObservable: any;
  constructor(
    private _authService: AuthService,
    private _appService: AppService,
    private _messageBrokerService: MessageBrokerService,
    private _userManagementService: UserManagementService,
    private _fb: FormBuilder,
    private _notificationsService: NotificationsService,
    private _errorHandler: GlobalErrorHandler
  ) {}

  ngOnInit(): void {


    this.userManagementForm = this._fb.group({
      projectId: '',
      selectAll: false,
      // usersProject: this._fb.array([this.initUsersProject()]),
      users: this._fb.array([]),
    });

    this.projectTermControl.setValue('');
    this.userTermControl.setValue('');

    if (this._authService.userInfo != null && this._authService.userInfo.accessToken) {
      this.appUserInfo = this._authService.userInfo;
      // this.ProcessSearch();
      // this.ProcessUsersSearch();
      this.isClearanceUser = this._authService.isUserInRole(environment.clearanceRole) || !environment.production;
    }
    else {
      console.error('UserManagement.ngOnInit()');
      var error = new ErrorModel();
      error.reloadRoute = '/';
      error.shouldRefreshApp = true;
      this._messageBrokerService.showErrorScreen(error);
    }
  }

  ngAfterViewInit(): void {
    SharedUtils.RemoveTooltipIfNeeded();
  }

  initUsersProject(user: IUserInfo = new IUserInfo()): FormGroup {
    return this._fb.group({
      selected: false,
      id: '',
      userId: user.userId,
      userName: user.userName,
      name: user.name,
      lastLoginDate: user.lastLoginDate
    });
  }

  selectAll(isChecked: boolean) {
    if (isChecked) {
      this.usersProject.controls.forEach(element => {
        element.get('selected').setValue(true);
      });
    } else {
      this.usersProject.controls.forEach(element => {
        element.get('selected').setValue(false);
      });
    }
  }

  removeSelected() {
    var toRemove: FormControl[] = [];
    this.usersProject.controls.forEach(element => {
      if (element.get('selected').value) {
        toRemove.push(element as FormControl);
      }
    });

    toRemove.forEach(element => {
      this.removeItem(element)
    });

    if (this.usersProject.controls.length == 0) {
      this.userManagementForm.get('selectAll').setValue(false);
    }

  }

  removeItem(i: any): void {
    let index = this.findControlIndexBasedOn(i, this.usersProject, 'userName');

    if (index == -1) {
      console.error('ClearanceItemComponent.removeImage() >> control passed in \'' + i + '\' is not of type CIImage');
      return;
    }
    this.usersProject.removeAt(index);
    this.userManagementForm.markAsDirty();
  }

  private findControlIndexBasedOn(i: any, controlsArray: FormArray, property: string): number {

    if (!i) {
      return;
    }

    if (!i.value || !i.value.hasOwnProperty(property) || !i.value[property]) {
      console.error('UserManagementComponent.findControlIndexBasedOn() >> no property \'' + property + '\' exists in formArray');
      return;
    }

    let controlIndex = controlsArray.controls.findIndex(c => c.get(property).value == i.value[property]);

    if (controlIndex == -1) {
      console.error('UserManagementComponent.findControlIndexBasedOn() >> control passed in \'' + i + '\' is not of type formArray');
      return;
    }

    return controlIndex;

  }

  get usersProject(): FormArray {
    return <FormArray>this.userManagementForm.get('users');
  }

  // set usersProject(arr: FormArray)  {
  //   this.userManagementForm.get('users').setValue([]);//.setValue(arr.value);
  // }

  get searchUsersLabel(): string {
    return this._selectedProject ? this._searchUsersLabel['default'] : this._searchUsersLabel['noproject'];
  }

  selectSearchedProject(val: any): void {
    this.resetForm(true);
    if (this.searchResults == null || this.searchResults.length == 0 || !val) {
      return;
    }

    var selectedProject = this.searchResults.find(it => it.ProjectName == val);

    if (selectedProject != null && selectedProject.ProjectId) {
      this._selectedProject = selectedProject;

      this._userManagementService.getUsersInProject(selectedProject.ProjectId)
        .subscribe(ret => {
          this.replaceUsersProject(ret);
          this.userManagementForm.markAsPristine();
          if (this.userTerm) {
            this.userTerm.nativeElement.focus();
          }
        }, err => {
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        });
    }
  }

  selectSearchedUsersByOption(selectedUser: IUserInfo): void {
    if (!this._selectedProject){
      this.userTermControl.setValue('');
      this._notificationsService.add(new Notification('error', 'Please select a project first.'));
      return;
    }
    if (!selectedUser) {
      return;
    }
    if (selectedUser.status === 'Pending') {
      this._notificationsService.add(new Notification('error', 'The selected user has pending his MyID registration'));
      this.userTermControl.setValue('');
      return;
    }
    if (selectedUser.status === 'Inactive') {
      this._notificationsService.add(new Notification('error', 'The selected user does not have a valid MyID registration'));
      this.userTermControl.setValue('');
      return;
    }

    let user = this.initUsersProject(selectedUser);
    if (!this.usersProject.value.find(o => o.userName == selectedUser.userName)) {
      this.usersProject.push(user);
      user.markAsDirty();
      this.usersProject.markAsDirty();
      this.userManagementForm.markAsDirty();
    }
    this.userTermControl.setValue('');
    if (this.userTerm) {
      this.userTerm.nativeElement.focus();
    }
  }

  get NewUsersOnList(): boolean {
    if (this.usersProject && this.usersProject.value.find(o => o.id === ''))
      return true;
    else
      return false;
  }

  get hasPendingUserChanges(): boolean {
    return !!(this.userManagementForm && this.userManagementForm.dirty);
  }

  get IsProjectSelected(): boolean {
    return this._selectedProject ? true : false;
  }

  public search(input: string) {
    if (input.length >= 3) {
      this._appService.rawSearch(false, input)
        .subscribe(s => {
          this.searchResults = s;
        }, err => {
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        }
        )
    }
    if (input.length == 0) {
      this._selectedProject = null;
      this.userManagementForm.markAsPristine();
    }
  }

  public searchUser(input: string) {
    if (input.length >= 3) {
      this.userSearchRunning=true;
      if (this.searchObservable){
        this.searchObservable.unsubscribe();
      }
      this.searchObservable = this._userManagementService.rawSearchByNameEmail(input).subscribe(s => {
          this.searchUsersResults = s;
        }, err => {
          if (err.status != 404) {
            this.userSearchRunning=false;
            this._errorHandler.processError(err);
          }
        }, () => {
          this.userSearchRunning=false;
        }
        );
    }
  }
  saveUsersProject(): void {
    if (this.hasPendingUserChanges && this.userManagementForm.valid) {
      var up: UsersProject = Object.assign({}, this.usersInProject, this.userManagementForm.value);
      up.projectId = this._selectedProject.ProjectId;

      this._userManagementService.updateUsersProject(up)
        .subscribe(
        (p) => this.onSaveComplete(false, up.users),
        (error: any) => {
          this._errorHandler.processError(error);
        }
        );
    } else if (!this.hasPendingUserChanges) {
      //this should not be
      this.onSaveComplete(true, []);
    }
  }

  onSaveComplete(resetProjects: boolean, users: IUserInProject[]): void {
    this.resetForm(resetProjects);
    this._notificationsService.add(new Notification('success', 'User has been successfully ' +
      (users && users.length > 0 ? 'assigned to' : 'removed from') +
      ' project \'' + this._selectedProject.ProjectName + '\''));
  }

  private replaceUsersProject(users: IUserInProject[]): void {
    while (this.usersProject.length) {
      this.usersProject.removeAt(0);
    }
    (users || []).forEach(r => {
      const fb = this.initUsersProject();
      fb.patchValue(r);
      this.usersProject.push(fb);
    });
  }

  resetForm(resetArray: boolean=false){
    if (this.userTermControl){
      this.userTermControl.setValue('');
      while (resetArray && this.usersProject.length) {
        this.usersProject.removeAt(0);
        }
    }
    this.userManagementForm.markAsPristine();
  }

  cancelClicked() {
    if (this.hasPendingUserChanges){
      this.userManagementForm.reset();
      this.userManagementForm.markAsPristine();
    }
    if (this._selectedProject){
      this.projectTermControl.setValue(this._selectedProject.ProjectName);
      this.selectSearchedProject(this._selectedProject.ProjectName);
    }
  }

  @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        return !this.userManagementForm.dirty;
    }

  openUserHelpModal(){
    if (this.helpComponent) {
      this.helpComponent.openHelpUserModal();
    }
  }

  openUserOptions(event: MouseEvent, selectedUser: IUserInfo){
    event.preventDefault();
    event.stopPropagation();
    this.selectedUserEmail = selectedUser.email;
    this.selectedUserStatus = selectedUser.status;

    const trigger = event.currentTarget as HTMLElement;
    const rect = trigger.getBoundingClientRect();
    const menuWidth = 200;
    const edgePadding = 16;
    let left = rect.left + 4 - 40;
    let top = rect.bottom + 4;
    const maxLeft = window.innerWidth - menuWidth - edgePadding;
    if (left > maxLeft) {
      left = maxLeft;
    }
    if (left < edgePadding) {
      left = edgePadding;
    }
    if (top < 8) {
      top = 8;
    }

    const clientX = `${left}px`;
    const clientY = `${top}px`;

    this.userMenuClientX = clientX;
    this.userMenuClientY = clientY;
    if (this.userMenuComponent) {
      this.userMenuComponent.openMenu(clientX, clientY, selectedUser.email, selectedUser.status);
    }
  }

  projectOptionSelected(projectName: string): void {
    this.selectSearchedProject(projectName);
  }

  userOptionSelected(selectedUser: IUserInfo): void {
    this.selectSearchedUsersByOption(selectedUser);
  }

  trackByProject(index: number, item: ProjectItem): string {
    return item && item.ProjectId ? item.ProjectId : `${index}`;
  }

  trackByUser(index: number, item: IUserInfo): string {
    return item && item.userId ? item.userId : `${index}`;
  }

}